/**
 * @module header/components/title
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import { trackClickWithMixpanel } from 'common/tracking';

/**
 * Header title component
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const HeaderTitle = ({
  title, subTitle, cta, buttonEventTracking=null, isTitleMain=false, children
}) => {
  const titleClasses = classnames('small-16 column', { 'medium-12': cta });

  return (<div className="row header-middle-content hide-for-small-only">
    <div className={titleClasses}>
      { isTitleMain?
      <h1 className="middle-left-title">{ title }</h1> :
      <h2 className="middle-left-title">{ title }</h2> }

      { subTitle && <h3 className="middle-left-subtitle">{ subTitle }</h3> }

      { children }
    </div>
    {cta && <div className="small-16 medium-4 column middle-right-action">
      <Link className="btn btn-primary" to={cta.url}>
        <span onClick={buttonEventTracking ? partial(trackClickWithMixpanel, buttonEventTracking.eventName, buttonEventTracking.eventData) : () => {} }>
{cta.label}
        </span>
      </Link>
    </div>}
  </div>);
};

HeaderTitle.propTypes = {
  title: PropTypes.string,
  isTitleMain: PropTypes.bool,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  cta: PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
  }),
};

export default HeaderTitle;



// WEBPACK FOOTER //
// ./header/components/title.jsx